/** Default stale time for TanStack Query (30 seconds). */
export const QUERY_STALE_TIME_MS = 1000 * 30;

/** Default retry count for failed queries. */
export const QUERY_RETRY_COUNT = 1;

/**
 * Poll interval for a running cycle's detail (`GET /cycles/{id}`). The payload is heavy
 * (full steps), so we keep it moderate; the granular live feed comes from the lightweight
 * `/messages` stream. Polling self-stops once the cycle's `state` is no longer "running".
 */
export const CYCLE_DETAIL_POLL_MS = 1000 * 3;

/** Poll interval for a list or detail with something in flight — a running or queued batch. */
export const LIVE_POLL_MS = 1000 * 5;

/**
 * Poll interval when nothing is in flight. The answer then changes when someone books a run
 * or a queued one starts, not second to second — and a hidden tab does not poll at all.
 */
export const IDLE_POLL_MS = 1000 * 60;

/** Ceiling for a live view's backoff (batch detail, case history) while its cycles keep reporting the same states. */
export const LIVE_POLL_MAX_MS = 1000 * 30;

/** Poll interval for the device list and drawer; `last_seen_time` moves in minutes, not seconds. */
export const DEVICES_POLL_MS = 1000 * 15;

/**
 * Runs fetched per page of a case's run history. The case page's History pane and the run
 * footer share one cache entry per case, so they share the page size too; the footer's
 * dialog shows five rows and scrolls into the rest, so a page has to be taller than that.
 */
export const RUN_HISTORY_PAGE_SIZE = 15;
